import _ from 'lodash';

import addCommercialTerms from './filter-terms/commercial';

angular.module('cian.filter')
  .factory('FilterTermsService', function () {
    var service = {};

    addCommercialTerms(service);

    // Комнатность
    service.roomTypes = [
      {value: 1, text: '1-комнатная'},
      {value: 2, text: '2-комнатная'},
      {value: 3, text: '3-комнатная'},
      {value: 4, text: '4-комнатная'},
      {value: 5, text: '5-комнатная'},
      {value: 6, text: '6-комнатная и более'},
      {value: 9, text: 'Студия'},
      {value: 7, text: 'Свободная планировка'}
    ];

    // Дата публикации
    service.publish_period = [
      {value: null, text: 'за любую дату'},
      {value: -2, text: 'сегодня'},
      {value: 300, text: 'за 5 мин.'},
      {value: 600, text: 'за 10 мин.'},
      {value: 900, text: 'за 15 мин.'},
      {value: 1200, text: 'за 20 мин.'},
      {value: 1800, text: 'за 30 мин.'},
      {value: 3600, text: 'за час'},
      {value: 7200, text: 'за 2 часа'},
      {value: 10800, text: 'за 3 часа'},
      {value: 14400, text: 'за 4 часа'},
      {value: 18000, text: 'за 5 часов'},
      {value: 21600, text: 'за 6 часов'},
      {value: 43200, text: 'за 12 часов'},
      {value: 64800, text: 'за 18 часов'},
      {value: 86400, text: 'за сутки'},
      {value: 129600, text: 'за 36 часов'},
      {value: 172800, text: 'за 2 дня'},
      {value: 259200, text: 'за 3 дня'},
      {value: 432000, text: 'за 5 дней'},
      {value: 864000, text: 'за 10 дней'},
      {value: 2592000, text: 'за месяц'}
    ];

    // Тип жилья
    service.building_status = [
      { value: 1, text: 'Только вторичка' },
      { value: 2, text: 'Квартиры в новостройках' },
    ];

    service.building_status_old = service.building_status.filter(
      item => [1].includes(item.value)
    );

    // Цифровые наборы
    service.numbers1to4 = getNumbers(4);
    service.numbers1to5 = getNumbers(5);
    service.numbers1to7 = getNumbers(7);
    service.numbers2to5 = getNumbers(5, 2);

    function getNumbers(to, from = 1) {
      const newTerm = [
        { value: null, text: 'неважно' }
      ];

      for (var i = from; i <= to; i++) {
        newTerm.push({ value: i });
      }

      return newTerm;
    }

    // Срок аренды
    service.for_day = [
      { value: '0', text: 'От года' },
      { value: '2', text: 'Несколько месяцев' },
      { value: '1', text: 'Посуточно' },
    ];

    service.for_day_long = service.for_day.filter(
      item => ['0', '2'].includes(item.value)
    );

    // Тип цены
    service.price_sm = [
      { text: 'за всё', value: null},
      { text: 'за м<sup>2</sup>', value: true}
    ]
    service.price_sm_rent = [
      { text: 'за месяц', value: null},
      { text: 'за м<sup>2</sup> в год', value: true}
    ]

    // Валюта
    service.currency = [
      {value: 2, text: 'В рублях'},
      {value: 1, text: 'В долларах'},
      {value: 3, text: 'В евро'}
    ]
    service.currency_office = [
      {value: 2, text: '<span class="cui-ruble"></span>'},
      {value: 1, text: '$'},
      {value: 3, text: '&euro;'}
    ]

    // Ремонт
    service.repair = [
      {value: 2, text: 'Косметический', tag: 'Косметический ремонт'},
      {value: 3, text: 'Евроремонт'},
      {value: 4, text: 'Дизайнерский', tag: 'Дизайнерский ремонт'},
      {value: 1, text: 'Без ремонта'},
    ];

    // Тип санузла
    service.wc_type = [
      {value: 1, text: 'Совмещенный'},
      {value: 2, text: 'Раздельный'},
    ];

    service.wc = [
      { value: null, text: 'неважно' },
      { value: 1, text: 'от 1' },
      { value: 2, text: 'от 2' },
      { value: 3, text: 'от 3' },
      { value: 4, text: 'от 4' },
    ];

    service.room_type = [
      {value: 1, text: 'Изолированные комнаты'},
      {value: 2, text: 'Смежные комнаты'},
    ];

    // Предоплата
    service.prepay = [
      {value: null, text: 'любая'},
      {value: 1, text: 'не более 1 месяца'},
      {value: 2, text: 'не более 2 месяцев'},
      {value: 3, text: 'не более 3 месяцев'},
      {value: 6, text: 'не более 6 месяцев'},
      {value: 12, text: 'не более года'}
    ];

    service.prepay_flat = service.prepay.filter(function(item) {
      return ([null, 1, 2, 3].indexOf(item.value) > -1);
    });

    // До метро
    service.only_foot = [
      { value: null, text: 'неважно' },
      { value: '2', text: 'пешком' },
      { value: '-2', text: 'транспортом' },
    ];

    // Окна
    service.windows_type = [
      { text: 'Во двор',         value: 0 },
      { text: 'На улицу',        value: 1 }
    ];

    // Тип дома
    service.house_material = [
      { text: 'Кирпичный',            value: 1 },
      { text: 'Деревянный',           value: 5 },
      { text: 'Монолитный',           value: 2 },
      { text: 'Панельный',            value: 3 },
      { text: 'Блочный',              value: 4 },
      { text: 'Кирпично-монолитный',  value: 8 },
      { text: 'Сталинский',           value: 6 },
      { text: 'Щитовой',              value: 7 },
    ];

    service._house_material_new = [
      { text: 'Панельный',            value: [3, 4] },
      { text: 'Кирпичный',            value: [1, 6] },
      { text: 'Монолитный',           value: [2, 8] },
    ];

    service.house_material_flat = service.house_material.filter(
      item => item.value !== 7
    );

    service.suburban_house_material = service.house_material.filter(
      item => [1, 2, 5, 7].includes(item.value)
    );

    // Тип продажи
    service.sost_type = [
      { value: 3, text: '214-ФЗ' },
      { value: 5, text: 'Договор ЖСК' },
      { value: 4, text: 'Переуступка' },
      { value: 6, text: 'Предварительный договор купли-продажи' },
      { value: 7, text: 'Договор инвестирования' },
      { value: 1, text: 'Свободная' },
      { value: 2, text: 'Альтернатива' },
    ];

    service.sost_type_common = service.sost_type.filter(
      item => [1, 2].includes(item.value)
    );

    service.sost_type_new = service.sost_type.filter(
      item => [3, 5, 4].includes(item.value)
    );


    service.composition = [
      { text: 'Любой',      value: 1 },
      { text: 'Семья',      value: 2 },
      { text: 'Мужчина',    value: 4 },
      { text: 'Женщина',    value: 3 }
    ];

    service.parking_type = [
      { value: 3, text: 'Наземная', tag: 'Наземная парковка' },
      { value: 4, text: 'Многоуровневая', tag: 'Многоуровневая парковка' },
      { value: 2, text: 'Подземная', tag: 'Подземная парковка' },
      { value: 1, text: 'На крыше', tag: 'Парковка на крыше' },
    ];

    service.commission_type = [
      { text: 'Эксклюзивная',   value: 1 },
      { text: 'Без комиссии',   value: 0 },
    ];



    // Загородка

    service.bedroom_total = [
      { text: 'неважно', value: null, title: 'Спален' },
      { value: 1, title: '1 спальня' },
      { value: 2, title: '2 спальни' },
      { value: 3, title: '3 спальни' },
      { value: 4, title: '4 спальни' },
      { value: 5, title: '5 спален' },
      { value: 6, title: '6 спален' },
      { value: 7, title: '7 спален' },
    ];

    service.wc_site = [
      { text: 'В доме',   value: 1 },
      { text: 'На улице', value: 2 }
    ];

    // Статус участка
    service.land_status = [
      { value: 4, text: 'Фермерское хозяйство' },
      { value: 1, text: 'Садоводство' },
      { value: 2, text: 'ИЖС' },
      { value: 3, text: 'Земля промназначения' },
      { value: 6, text: 'Инвестпроект' },
      { value: 5, text: 'ДНП' },
    ];

    service.land_status_house = service.land_status.filter(
      item => item.value !== 6
    );

    // Отопление
    service.heating_source_type = [
      { text: 'Газовое',          value: 2, tag: 'Газовое отопление' },
      { text: 'Угольное',         value: 3, tag: 'Угольное отопление' },
      { text: 'Печь',             value: 4 },
      { text: 'Камин',            value: 5 },
      { text: 'Не отапливается',  value: 1, tag: 'Без отопления' }
    ];



    // Новостройки

    service.hand_over = [
      { text: 'Дом сдан', value: true }
    ]

    service.year = [];
    // Генерим года сдачи
    var currentYear = (new Date()).getFullYear();
    for (var i = 0; i < 4; i++) {
      var year = currentYear + i;
      service.year.push({
        value: year
      })
    }

    service.yeargte = [
      { text: 'Позднее', value: currentYear + 4}
    ]



    // Bools
    service.has_furniture = [
      { text: 'С мебелью',  value: true },
      { text: 'Без мебели', value: false }
    ];

    service.is_first_floor = [
      { text: 'Первый этаж',    value: true },
      { text: 'Не первый этаж', value: false }
    ];

    service.has_decoration = [
      { text: 'С отделкой',  value: true },
      { text: 'Без отделки', value: false }
    ];

    service.from_developer = [
      { text: 'От застройщиков',          value: true },
      { text: 'От агентов и частных лиц', value: false }
    ];

    service.include_new_moscow = [
      { text: 'Новая Москва', value: true },
      { text: 'Без Новой Москвы', value: false },
    ];

    service.only_flat = [
      { value: true, text: 'Без апартаментов' },
    ];

    service.apartment = [
      { value: true, text: 'Только апартаменты' },
    ];

    service.security = [
      { value: true, text: 'С охраной' },
    ];



    // Поля, которые есть на старых фильтрах, но нет на новых

    service.house_type = [
      { value: 5, text: 'блочный' },
      { value: 6, text: 'деревянный' },
      { value: 4, text: 'кирпично монолитный' },
      { value: 2, text: 'кирпичный' },
      { value: 3, text: 'монолитный' },
      { value: 1, text: 'панельный' },
      { value: 7, text: 'сталинский' },
      { value: 9, text: 'старый фонд' },
      { value: 8, text: 'щитовой' },
    ];

    service.building = [
      { value: 2, text: 'жилой фонд' },
      { value: 1, text: 'нежилой фонд' },
    ];



    // Генерим объекты для быстрого поиска текста по value
    angular.forEach(service, function(propValue, propName) {
      if (angular.isArray(propValue) && angular.isObject(_.first(propValue))) {
        var objectName = propName + 'Texts';
        service[objectName] = {};

        angular.forEach(propValue, function(item) {
          // Нет текста — используем значение
          item.text = item.text || item.value.toString();

          service[objectName][item.value] = item.tag ? item.tag : item.text;
        })
      }
    });

    return service;
  });



// WEBPACK FOOTER //
// ./src/components/filter/src/scripts/cian.filter-terms.service.js